/**
 * useCreditLien
 * Fetches the active WalletLien + collection history for a credit (DEFAULTED).
 *
 * Backend: GET /credit-worker/backoffice/credits/{creditId}/lien
 */

import { useQuery } from '@tanstack/react-query';
import { getCreditLien } from '@/services/credit-worker.service';

export function useCreditLien(creditId: string | undefined, pageSize = 20) {
  const query = useQuery({
    queryKey: ['lien', 'by-credit', creditId, pageSize],
    queryFn: () => getCreditLien(creditId!, pageSize),
    enabled: Boolean(creditId),
  });

  return {
    lien: query.data?.data?.lien ?? null,
    collections: query.data?.data?.collections ?? [],
    nextPageKey: query.data?.data?.nextPageKey ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: () => void query.refetch(),
  };
}
